import React, { useState, useEffect } from "react";

import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";

import { getStockNews } from "../Service/data";

const StockNews = (props) => {
  const [data, setData] = useState();
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        getStockNews(props.title).then((data) => {
          setData(data);
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (data !== undefined && data !== null) {
      setLoading(false);
      setNoData(false);
    }
  }, [data]);

  return (
    <div>
      {loading && <CircularProgress />}
      {noData && <Typography>No data was received</Typography>}
      <List sx={{ width: "100%", width: '100%', maxHeight: '400px', overflow: 'scroll', bgcolor: "background.paper" }}>
        {data !== null &&
          data !== undefined &&
          data.map((row) => (
            <div>
              <ListItem alignItems="flex-start" href={row['url']}>
                <ListItemAvatar>
                  <Avatar alt="img" src={row['image']} />
                </ListItemAvatar>
                <ListItemText
                  primary={<Typography component="a" href={row['url']} target="_blank">{row['title']}</Typography>}
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        {`${row['publishedDate']} : `}
                      </Typography>
                      <Typography sx={{ display: "inline" }} variant="subtitle2">
                      {row['text']}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" />
            </div>
          ))}
      </List>
    </div>
  );
};

export default StockNews;
